import { clientePedido } from '../../apiClient/index'

const moduloCuentaCorriente = {
    namespaced: true,
    
    state: {
        filtrosCuentaCorriente: {
            cuentaCorriente: null,
            agrupamiento: null
        }
    },
    actions: {
        getCuentasCorrientes(_, payload) {
            return new Promise((resolve, reject) => {
                clientePedido.get('/api/cuentas/GetCuentasCorrientes', {params: payload})
                             .then(response => {
                                resolve(response.data)
                             })
                             .catch(error => {
                                reject(error.response.data)
                             })
            })
        },
        getCuentasPendientes(_, payload) {
            return new Promise((resolve, reject) => {
                clientePedido.get('/api/cuentas/GetPendientes', {params: payload})
                             .then(response => {
                                resolve(response.data)
                             })
                             .catch(error => {
                                reject(error.response.data)
                             })
            })
        },
        exportarExcel(_, payload) {
            return new Promise((resolve, reject) => {
                clientePedido.post('/api/cuentas/ExportExcelPendientes', payload)
                             .then(response => {
                                resolve(response.data)
                             })
                             .catch(error => {
                                reject(error.response.data)
                             })
            })
        },
        setFiltrosCuentaCorriente(context,payload) {
            context.commit("setFiltrosCuentaCorriente", payload);
        }
    },
    mutations: {
        setFiltrosCuentaCorriente(state, payload)
        {
          state.filtrosCuentaCorriente = payload
        },
    }
}

export default moduloCuentaCorriente